import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { InputField } from '../../inputField';
import GenericSelection from '../../GenericSelection';

import { fetchBaseUsers } from '../../../../actions/settings_actions';

function getVendors(companyid, success) {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/vendor/?Company_id=${companyid}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    success(res.data);
  }).catch(res => {
    alert(JSON.stringify(res.data));
  })
}

const mergePOAPI = (poIds, data, success) => {
  axios({
    method: 'POST',
    data,
    url: `${ROOT_URL}v1/purchase/merge_purchase_invoice/${poIds}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    success();
  }).catch(err => {
    if (err.data) {
      alert(JSON.stringify(err.data))
    } else {
      alert(JSON.stringify(err));
    }
  });
}

const modalStyle = {
  width: '500px',
  height: '260px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '40px',
  }
}

class ReveivedPOMerge extends Component {
  state = {
    vendors: [],
    selectedVendor: '',
  }

  setVendorState = (data) => this.setState({ vendors: data.map(vendor => ({ label: vendor.Name, value: vendor.Vendor_id })) });
  componentDidMount() {
    getVendors(this.props.Company_id, this.setVendorState)
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedCompany !== this.props.selectedCompany) {
      getVendors(this.props.Company_id, this.setVendorState)
    }
  }

  renderSalesSelection = () => {
    return (
      <div className="customer-sales">
        <GenericSelection
          options={this.state.vendors}
          value={this.state.selectedVendor}
          setSelected={(e) => {
            this.setState({ selectedVendor: e })
          }}
        />
      </div>
    )
  }

  render() {
    const poNums = this.props.selectedRows.map(row => row.WarehouseReceiveNum);
    return (
      <form style={styles.container} id="receive-merge-modal">
        {/* <h4>Location Change</h4> */}
        <div style={{ width: '100%', textAlign: 'center', height: '130px', fontSize: '15px', fontWeight: 'bold' }}>
          <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ margin: '5px' }}><Translate value="vendor" />:</div>
            <div style={{ margin: '5px' }}>
              {this.renderSalesSelection()}
            </div>
          </div>
          <p style={{ height: '90px', overflow: 'auto' }}>
            {poNums.join(',')}
          </p>
        </div>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '10px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.onClose()
            }}
          >
            <Translate value="cancel" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              const poIds = this.props.selectedRows.map(row => row.WarehouseReceive_id).join(',')
              const success = this.props.handleMergePoSuccess;
              mergePOAPI(poIds, {vendor_id: this.state.selectedVendor.value}, success);
            }}
          >
            <Translate value="merge" />
          </Button>
        </div>
      </form>
    )
  }
}

const ReceivedPOMergeModal = ({ isVisible, onClose, onConfirm, selectedRows, handleMergePoSuccess, Company_id }) => (
  <SkyLightStateless
    title={'Merge Received PO'}
    onCloseClicked={onClose}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <ReveivedPOMerge selectedRows={selectedRows} onClose={onClose} onConfirm={onConfirm} handleMergePoSuccess={handleMergePoSuccess} Company_id={Company_id} />
  </SkyLightStateless>
)

ReceivedPOMergeModal.propTypes = propTypes
ReceivedPOMergeModal.defaultProps = defaultProps

const mapState = state => ({
  users: state.settings.all,
  selectedCompany: state.header.selectedCompany,
});

export default connect(mapState, {
  fetchBaseUsers,
})(ReceivedPOMergeModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/warehouseManagement/ReceivedPOMergeModal.jsx